import { Link, Route } from "react-router-dom";
import Layout from "./Layout";
// import Dashboard from "./Dashboard";
import Expenses from "./pages/Expenses";
import { loadExpense, loadExpenseImages, loadExpenseOptions, loadExpenses } from "./apis/expenseAPI";
import ExpenseChanges from "./pages/ExpenseChanges";
import ExpenseCategories from "./pages/ExpenseCategories";
import { loadExpenseCategories, loadExpenseCategory } from "./apis/expenseCategoryAPI";
import ExpenseCategoryChanges from "./pages/ExpenseCategoryChanges";
import ExpenseReports from "./pages/ExpenseReports";
import { loadExpenseReport, loadExpenseReports } from "./apis/expenseReportAPI";
import ExpenseReportChanges from "./pages/ExpenseReportChanges";
import Settings from "./pages/Settings";
import { loadSettings } from "./apis/settingsAPI";
import ExpenseOptions from "./pages/ExpenseOptions";
import ExpenseImages from "./pages/ExpenseImages";





const salesRouter = () => (
  <Route path="/expense" element={<Layout />} handle={{ crumb: () => <Link to={'/sales'}>Overview</Link>}}>  
    <Route index element={<Expenses />} loader={loadExpenses}/>
    <Route path="expenses" element={<Expenses />} loader={loadExpenses} />
    <Route path="expenses/option/:filter" element={<ExpenseOptions />} loader={params => loadExpenseOptions(params.params.filter)} />
    <Route path="expenses/:action" element={<ExpenseChanges />} loader={params => loadExpense(params.params.action)} />
    <Route path="expenses/:action/images/:id" element={<ExpenseImages />} loader={params => loadExpenseImages(params.params.id)} />
    <Route path="expenses/:action/:new" element={<ExpenseReportChanges />} loader={params => loadExpenseReport(params.params.new)} />
    <Route path="expense-categories" element={<ExpenseCategories />} loader={loadExpenseCategories} />
    <Route path="expense-categories/:action" element={<ExpenseCategoryChanges />} loader={params => loadExpenseCategory(params.params.action)} />
    <Route path="reports" element={<ExpenseReports />} loader={loadExpenseReports} />
    <Route path="reports/:action" element={<ExpenseReportChanges />} loader={params => loadExpenseReport(params.params.action)} />
    <Route path="settings" element={<Settings />} loader={loadSettings} />
  </Route>
);


export default salesRouter;